<div class="player-audio-subtitles">
  <div class="player-audio-subtitles__container">
    <app-player-subtitles (closeDialog)="close()"></app-player-subtitles>
  </div>
</div>